import { z } from "zod";

export const MasterLicenseAgreementItemSchema = z
  .object({
    Id: z.string(),
    Name: z.string().optional(),
    Text: z.string().optional(),
    PublishedDate: z.string().optional(),
    StatusCode: z.number().optional(),
  })
  .transform((data) => ({
    ...data,
    PublishedDate: data.PublishedDate
      ? new Date(data.PublishedDate)
      : undefined,
  }));

export type MasterLicenseAgreementItemType = z.infer<
  typeof MasterLicenseAgreementItemSchema
>;
